import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { PollingConfiguration } from '@platform-frontend/platform';
import { map } from 'rxjs/operators';
import { CompleteOAuth, VerifyOAuth } from './o-auth.actions';
import { OAuthState } from './o-auth.state';

@Injectable({
  providedIn: 'root'
})
export class OAuthService {
  constructor(private store: Store) {}

  getPollingConfiguration(): PollingConfiguration {
    return {
      poll: (timeout: number) => this.store.dispatch(new VerifyOAuth(timeout)).pipe(map(() => this.store.selectSnapshot(OAuthState.verified))),
      complete: () => this.store.dispatch(new CompleteOAuth())
    };
  }
}
